(function() {
  // A shopper who tries three different sizes is telling you something. This
  // watches for that and offers the size recommender — the same panel the
  // "Not sure about your size?" button opens, opened by clicking that very
  // button, so there is one way in and no second copy of its behaviour here.
  var SIZE_LEGEND = /taglia|taglie|size|misura|numero/i;
  var DISTINCT_SIZES_NEEDED = 3;

  var chosen = [];
  var adopted = null;
  var recommenderSeen = false;
  var lastFocused = null;

  // The key carries a version because the first release of this recorded its
  // offer against a dialog the shopper never saw — see dialogNode below. Those
  // sessions would otherwise stay silenced by a promise that was not kept.
  function storageKey() {
    return 'sks-size-help:2:' + window.location.pathname;
  }

  // The product section re-renders on every variant change, and the theme's
  // <product-rerender> replaces each of its liquid blocks wholesale — this
  // dialog among them. The first release held a reference from page load and
  // was, from the first size change onwards, unhiding a node that had been
  // detached from the document: no error, no dialog, nothing to see.
  //
  // So it is adopted into <body> once, where the re-render cannot reach it, and
  // the copy each re-render brings with it is dropped on the next pass rather
  // than left to duplicate an id.
  function dialogNode() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll('.sks-size-help'));

    if (!adopted || adopted.parentElement !== document.body) {
      adopted = nodes[0] || null;
      if (!adopted) return null;
      document.body.appendChild(adopted);
      wireDialog(adopted);
    }

    nodes.forEach(function(node) {
      if (node !== adopted) node.remove();
    });

    return adopted;
  }

  // Once per product per session. The offer is worth making; making it again
  // to someone who has already said no is just an obstacle between them and
  // the size they were choosing.
  function alreadyOffered() {
    try {
      return window.sessionStorage.getItem(storageKey()) === '1';
    } catch (error) {
      return false;
    }
  }

  function rememberOffered() {
    try {
      window.sessionStorage.setItem(storageKey(), '1');
    } catch (error) {
      /* Private browsing, blocked storage: offer it again rather than not at all. */
    }
  }

  // The recommender's own trigger, and only while it is on screen: the app
  // reveals it after checking whether this product has a chart at all, so on a
  // product without one there is nothing to offer and nothing to open.
  function helpButton() {
    var button = document.getElementById('sz-btn');
    if (!button) return null;

    var rect = button.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return null;

    recommenderSeen = true;
    return button;
  }

  function normalize(text) {
    return String(text || '')
      .split('\n')[0]
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  // Which group of options is the size. Named by its legend where there is one;
  // otherwise a single group of options on a product is the size by default,
  // and where there are several unnamed ones the guess is not worth making —
  // counting a shopper's colour changes as size doubt would offer help to
  // somebody who is not lost.
  function sizeFieldset() {
    var sets = Array.prototype.slice
      .call(document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset'))
      .filter(function(fieldset) {
        return !fieldset.closest('.zrx-sticky-atc-bar');
      });

    var named = sets.filter(function(fieldset) {
      var legend = fieldset.querySelector('legend');
      return SIZE_LEGEND.test(legend ? legend.textContent : '');
    });

    if (named.length) return named[0];
    return sets.length === 1 ? sets[0] : null;
  }

  function labelFor(input) {
    var label = null;

    if (input.id && document.querySelector) {
      label = document.querySelector('label[for="' + input.id.replace(/["\\]/g, '\\$&') + '"]');
    }
    if (!label && input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
      label = input.nextElementSibling;
    }

    return normalize(label ? label.textContent : input.value);
  }

  function sizeFromChange(target) {
    if (!target || !target.matches) return '';

    if (target.matches('.zrx-sticky-atc-select')) {
      var option = target.options ? target.options[target.selectedIndex] : null;
      return option ? normalize(option.textContent) : '';
    }

    if (target.matches('input[data-option-position]')) {
      if (target.closest('.zrx-sticky-atc-bar')) return '';

      var fieldset = sizeFieldset();
      if (!fieldset || !fieldset.contains(target)) return '';

      return labelFor(target);
    }

    return '';
  }

  function distinctCount(list) {
    return list.filter(function(size, index) {
      return list.indexOf(size) === index;
    }).length;
  }

  function record(size) {
    if (!size) return;

    // The picker and the sticky bar are kept in step with each other, so one
    // tap raises a change event on both. The second carries the size the first
    // just set, and a size that is already the current one is not a choice.
    if (chosen[chosen.length - 1] === size) return;

    chosen.push(size);
    if (distinctCount(chosen) >= DISTINCT_SIZES_NEEDED) offer();
  }

  function open(dialog) {
    lastFocused = document.activeElement;
    dialog.hidden = false;
    // Two frames: the first puts the dialog in the layout, the second lets the
    // transition have a starting point to run from.
    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(function() {
        dialog.classList.add('is-open');
        var cta = dialog.querySelector('[data-size-help-open]');
        if (cta) cta.focus();
      });
    });
  }

  function close(dialog) {
    dialog.classList.remove('is-open');
    window.setTimeout(function() {
      dialog.hidden = true;
    }, 220);

    if (lastFocused && lastFocused.focus) lastFocused.focus();
    lastFocused = null;
  }

  // A re-render is in flight while the shopper is still tapping, and it takes
  // the recommender's button with it: the markup comes back from the server
  // hidden, and the app reveals it again once it has re-checked the product.
  // Offering during that gap would put a call to action on screen with nothing
  // behind it, so it waits for the button rather than firing blind — and gives
  // up if it never comes back, which is what a product with no chart looks like.
  var WAIT_FOR_BUTTON_MS = 2000;
  var waiting = false;

  function offer() {
    var dialog = dialogNode();
    if (!dialog || !dialog.hidden || alreadyOffered() || waiting) return;
    if (!recommenderSeen && !document.getElementById('sz-btn')) return;

    var deadline = Date.now() + WAIT_FOR_BUTTON_MS;
    waiting = true;

    (function attempt() {
      var current = dialogNode();

      if (helpButton() && current && current.hidden && !alreadyOffered()) {
        waiting = false;
        rememberOffered();
        open(current);
        return;
      }

      if (Date.now() > deadline) {
        waiting = false;
        return;
      }

      window.setTimeout(attempt, 120);
    }());
  }

  // Long enough to be after the re-render, twice in case the first was early.
  function sweepSoon() {
    window.setTimeout(dialogNode, 500);
    window.setTimeout(dialogNode, 1500);
  }

  function wireDialog(dialog) {
    if (dialog.getAttribute('data-size-help-wired') === 'true') return;
    dialog.setAttribute('data-size-help-wired', 'true');

    dialog.addEventListener('click', function(event) {
      if (event.target === dialog || event.target.closest('[data-size-help-close]')) {
        close(dialog);
        return;
      }

      if (event.target.closest('[data-size-help-open]')) {
        var button = helpButton();
        close(dialog);
        if (button) button.click();
      }
    });
  }

  function wire() {
    if (!dialogNode()) return;

    // These live on the document, not on the dialog, so the section replacing
    // itself underneath them changes nothing.
    document.addEventListener('keydown', function(event) {
      var dialog = adopted;
      if (event.key === 'Escape' && dialog && !dialog.hidden) close(dialog);
    });

    document.addEventListener('change', function(event) {
      // A change is what sets a re-render going, and a re-render brings a fresh
      // copy of this dialog into the section a moment later. Sweeping after it
      // keeps exactly one in the document rather than leaving a hidden twin
      // holding the same id until the next size is tapped.
      sweepSoon();

      if (adopted && !adopted.hidden) return;
      record(sizeFromChange(event.target));
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
}());
